import { render } from "./MasterEditButton.vue?vue&type=template&id=72042ded&scoped=true"
import script from "./MasterEditButton.vue?vue&type=script&lang=js"
export * from "./MasterEditButton.vue?vue&type=script&lang=js"

import "./MasterEditButton.vue?vue&type=style&index=0&id=72042ded&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72042ded"]])

export default __exports__